import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Pedidos from './Pedidos';

function Planes() {
  const [planes, setPlanes] = useState([]);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [planSeleccionado, setPlanSeleccionado] = useState(null);
  const [editandoPlan, setEditandoPlan] = useState(null);
  const [form, setForm] = useState({
    fecha: '',
    comentario: '',
    flete_propio: false,
    flete_propio_importe: '',
    flete_tercero: false,
    flete_importe: '',
    capacidad_bultos: ''
  });

  const token = localStorage.getItem('token');

  const cargarPlanes = async () => {
    try {
      const res = await axios.get('https://comprasmercadomodelo.online/api/planes', {
        headers: { authorization: token }
      });
      setPlanes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => { cargarPlanes(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const flete_tipo = form.flete_propio && form.flete_tercero ? 'ambos' :
                       form.flete_propio ? 'propio' :
                       form.flete_tercero ? 'tercero' : 'propio';
    try {
      await axios.post('https://comprasmercadomodelo.online/api/planes', {
        ...form,
        flete_tipo,
        flete_importe: form.flete_tercero ? form.flete_importe : 0,
        flete_propio_importe: form.flete_propio ? form.flete_propio_importe : 0
      }, {
        headers: { authorization: token }
      });
      setMostrarForm(false);
      setForm({ fecha: '', comentario: '', flete_propio: false, flete_propio_importe: '', flete_tercero: false, flete_importe: '', capacidad_bultos: '' });
      cargarPlanes();
    } catch (err) {
      console.error(err);
    }
  };

  const eliminarPlan = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm('¿Eliminar este plan y todos sus pedidos? Esta acción no se puede deshacer.')) return;
    try {
      await axios.delete(`https://comprasmercadomodelo.online/api/planes/${id}`, {
        headers: { authorization: token }
      });
      cargarPlanes();
    } catch (err) {
      console.error(err);
    }
  };

  const reabrirPlan = async (e, plan) => {
    e.stopPropagation();
    const anterior = { cerrado: "descargado", descargado: "cargado", cargado: "abierto" }[plan.estado];
    if (!anterior) return;
    if (!window.confirm("Reabrir este plan como " + anterior + "?")) return;
    try {
      await axios.put("https://comprasmercadomodelo.online/api/planes/" + plan.id + "/estado", { estado: anterior }, {
        headers: { authorization: token }
      });
      cargarPlanes();
    } catch (err) {
      console.error(err);
    }
  };
  const abrirEdicionPlan = (e, plan) => {
    e.stopPropagation();
    setEditandoPlan({
      id: plan.id,
      fecha: plan.fecha ? (() => { const d = new Date(plan.fecha); d.setMinutes(d.getMinutes() + d.getTimezoneOffset()); return d.toISOString().substring(0, 10); })() : "",
      flete_tipo: plan.flete_tipo || "",
      flete_importe: plan.flete_importe || 0,
      flete_propio_importe: plan.flete_propio_importe || 0,
      capacidad_bultos: plan.capacidad_bultos || 0,
      comentario: plan.comentario || ""
    });
  };
  const guardarEdicionPlan = async () => {
    try {
      await axios.put(`https://comprasmercadomodelo.online/api/planes/${editandoPlan.id}`, editandoPlan, {
        headers: { authorization: token }
      });
      setEditandoPlan(null);
      cargarPlanes();
    } catch (err) {
      console.error(err);
    }
  };

  const getColorEstado = (estado) => {
    const colores = { abierto: '#3498db', cargado: '#f39c12', descargado: '#9b59b6', cerrado: '#27ae60' };
    return colores[estado] || '#95a5a6';
  };

  const getPorcentajeBultos = (total, capacidad) => {
    if (!capacidad || capacidad === 0) return 0;
    return Math.min((total / capacidad) * 100, 100);
  };

  if (planSeleccionado) {
    return <Pedidos planId={planSeleccionado} onVolver={() => { setPlanSeleccionado(null); cargarPlanes(); }} />;
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h3 style={styles.titulo}>📋 Planes de Compra</h3>
        <button style={styles.botonNuevo} onClick={() => setMostrarForm(!mostrarForm)}>
          {mostrarForm ? '✕ Cancelar' : '+ Nuevo Plan'}
        </button>
      </div>

      {mostrarForm && (
        <div style={styles.formulario}>
          <h4 style={styles.tituloForm}>Nuevo Plan de Compras</h4>
          <form onSubmit={handleSubmit}>
            <div style={styles.fila}>
              <div style={styles.campo}>
                <label style={styles.label}>Fecha</label>
                <input style={styles.input} type="date" value={form.fecha}
                  onChange={(e) => setForm({ ...form, fecha: e.target.value })} required />
              </div>
              <div style={styles.campo}>
                <label style={styles.label}>Capacidad máx. bultos 📦</label>
                <input style={styles.input} type="number" placeholder="Ej: 200"
                  value={form.capacidad_bultos}
                  onChange={(e) => setForm({ ...form, capacidad_bultos: e.target.value })} />
              </div>
            </div>

            <div style={styles.fleteBox}>
              <label style={styles.labelFlete}>🚛 Flete</label>
              <div style={styles.fleteOpciones}>
                <div style={styles.fleteOpcion}>
                  <label style={styles.checkLabel}>
                    <input type="checkbox" checked={form.flete_propio}
                      onChange={(e) => setForm({ ...form, flete_propio: e.target.checked })} />
                    &nbsp; Flete Propio
                  </label>
                  {form.flete_propio && (
                    <input style={styles.inputFlete} type="number" placeholder="$ importe (opcional)"
                      value={form.flete_propio_importe}
                      onChange={(e) => setForm({ ...form, flete_propio_importe: e.target.value })} />
                  )}
                </div>
                <div style={styles.fleteOpcion}>
                  <label style={styles.checkLabel}>
                    <input type="checkbox" checked={form.flete_tercero}
                      onChange={(e) => setForm({ ...form, flete_tercero: e.target.checked })} />
                    &nbsp; Flete Tercero
                  </label>
                  {form.flete_tercero && (
                    <input style={styles.inputFlete} type="number" placeholder="$ importe"
                      value={form.flete_importe}
                      onChange={(e) => setForm({ ...form, flete_importe: e.target.value })} />
                  )}
                </div>
              </div>
            </div>

            <div style={styles.campo}>
              <label style={styles.label}>Comentario</label>
              <textarea style={styles.textarea} placeholder="Observaciones del plan..."
                value={form.comentario}
                onChange={(e) => setForm({ ...form, comentario: e.target.value })} />
            </div>

            <button style={styles.botonGuardar} type="submit">💾 Guardar Plan</button>
          </form>
        </div>
      )}

      <div style={styles.lista}>
        {planes.length === 0 ? (
          <p style={styles.sinPlanes}>No hay planes creados todavía</p>
        ) : (
          planes.map((plan) => {
            const porcentaje = getPorcentajeBultos(plan.total_bultos, plan.capacidad_bultos);
            const alertaBultos = plan.capacidad_bultos > 0 && (plan.capacidad_bultos - plan.total_bultos) <= 100;
            const tieneAmbosFletes = plan.flete_tipo === 'ambos';

            return (
              <div key={plan.id} style={styles.tarjeta} onClick={() => setPlanSeleccionado(plan.id)}>
                <div style={styles.tarjetaHeader}>
                  <span style={styles.fecha}>📅 {new Date(plan.fecha).toLocaleDateString('es-AR')}</span>
                  <div style={styles.tarjetaHeaderDerecha}>
                    <span style={{ ...styles.estado, backgroundColor: getColorEstado(plan.estado) }}>
                      {plan.estado}
                    </span>
                    {plan.estado !== "abierto" && (
                      <button style={styles.botonReabrirPlan}
                        onClick={(e) => reabrirPlan(e, plan)}>
                        Reabrir
                      </button>
                    )}
                    <button style={styles.botonEliminarPlan}
                      onClick={(e) => abrirEdicionPlan(e, plan)}>
                      Editar
                    </button>
                    <button style={styles.botonEliminarPlan}
                      onClick={(e) => eliminarPlan(e, plan.id)}>
                      🗑️
                    </button>
                  </div>
                </div>

                <p style={styles.comentario}>{plan.comentario || 'Sin comentarios'}</p>

                <div style={styles.tarjetaFooter}>
                  <span style={styles.info}>📦 {plan.total_pedidos} pedidos</span>
                  {tieneAmbosFletes ? (
                    <>
                      <span style={styles.info}>🚛 Propio{plan.flete_propio_importe > 0 ? ` $${Number(plan.flete_propio_importe).toLocaleString('es-AR')}` : ''}</span>
                      <span style={styles.info}>🚚 Tercero{plan.flete_importe > 0 ? ` $${Number(plan.flete_importe).toLocaleString('es-AR')}` : ''}</span>
                    </>
                  ) : (
                    <span style={styles.info}>
                      🚛 {plan.flete_tipo}
                      {plan.flete_tipo === 'tercero' && plan.flete_importe > 0 && ` $${Number(plan.flete_importe).toLocaleString('es-AR')}`}
                    </span>
                  )}
                  {plan.capacidad_bultos > 0 && (
                    <span style={alertaBultos ? styles.alertaBultos : styles.info}>
                      📦 {plan.total_bultos}/{plan.capacidad_bultos} bultos {alertaBultos && '⚠️'}
                    </span>
                  )}
                  <span style={styles.verDetalle}>Ver pedidos →</span>
                </div>

                {plan.capacidad_bultos > 0 && (
                  <div style={styles.barraContainer}>
                    <div style={{
                      ...styles.barraRelleno,
                      width: `${porcentaje}%`,
                      backgroundColor: porcentaje >= 90 ? '#e74c3c' : porcentaje >= 70 ? '#f39c12' : '#27ae60'
                    }} />
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
      {editandoPlan && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContenido}>
            <h3>Editar plan</h3>
            <div style={styles.campo}>
              <label style={styles.label}>Fecha</label>
              <input style={styles.input} type="date" value={editandoPlan.fecha}
                onChange={(e) => setEditandoPlan({ ...editandoPlan, fecha: e.target.value })} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Tipo de flete</label>
              <select style={styles.input} value={editandoPlan.flete_tipo}
                onChange={(e) => setEditandoPlan({ ...editandoPlan, flete_tipo: e.target.value })}>
                <option value="propio">Propio</option>
                <option value="tercero">Tercero</option>
                <option value="ambos">Ambos</option>
              </select>
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Importe flete tercero</label>
              <input style={styles.input} type="number" value={editandoPlan.flete_importe}
                onChange={(e) => setEditandoPlan({ ...editandoPlan, flete_importe: e.target.value })} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Importe flete propio</label>
              <input style={styles.input} type="number" value={editandoPlan.flete_propio_importe}
                onChange={(e) => setEditandoPlan({ ...editandoPlan, flete_propio_importe: e.target.value })} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Capacidad bultos</label>
              <input style={styles.input} type="number" value={editandoPlan.capacidad_bultos}
                onChange={(e) => setEditandoPlan({ ...editandoPlan, capacidad_bultos: e.target.value })} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Comentario</label>
              <input style={styles.input} type="text" value={editandoPlan.comentario}
                onChange={(e) => setEditandoPlan({ ...editandoPlan, comentario: e.target.value })} />
            </div>
            <div style={styles.modalBotones}>
              <button style={styles.botonGuardar} onClick={guardarEdicionPlan}>Guardar</button>
              <button style={styles.botonCancelarPeq} onClick={() => setEditandoPlan(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: { padding: '20px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  titulo: { color: '#2c3e50', fontSize: '22px', margin: 0 },
  botonNuevo: { backgroundColor: '#27ae60', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  formulario: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', marginBottom: '20px' },
  tituloForm: { color: '#2c3e50', marginBottom: '20px' },
  fila: { display: 'flex', gap: '15px', marginBottom: '15px', flexWrap: 'wrap' },
  campo: { flex: 1, display: 'flex', flexDirection: 'column', minWidth: '150px', marginBottom: '15px' },
  label: { fontSize: '13px', color: '#7f8c8d', marginBottom: '5px' },
  input: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' },
  textarea: { padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', minHeight: '80px' },
  fleteBox: { backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', marginBottom: '15px' },
  labelFlete: { fontSize: '14px', fontWeight: 'bold', color: '#2c3e50', marginBottom: '10px', display: 'block' },
  fleteOpciones: { display: 'flex', gap: '30px', flexWrap: 'wrap' },
  fleteOpcion: { display: 'flex', flexDirection: 'column', gap: '8px' },
  checkLabel: { fontSize: '14px', color: '#2c3e50', cursor: 'pointer', display: 'flex', alignItems: 'center' },
  inputFlete: { padding: '8px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', width: '160px' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalContenido: { backgroundColor: 'white', padding: '25px', borderRadius: '10px', width: '90%', maxWidth: '450px', maxHeight: '90vh', overflowY: 'auto' },
  modalBotones: { display: 'flex', gap: '10px', marginTop: '15px' },
  botonCancelarPeq: { backgroundColor: '#95a5a6', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' },
  botonGuardar: { backgroundColor: '#2980b9', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', marginTop: '10px' },
  lista: { display: 'flex', flexDirection: 'column', gap: '15px' },
  sinPlanes: { textAlign: 'center', color: '#95a5a6', fontSize: '16px', marginTop: '40px' },
  tarjeta: { backgroundColor: 'white', padding: '20px', borderRadius: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', cursor: 'pointer' },
  tarjetaHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
  tarjetaHeaderDerecha: { display: 'flex', alignItems: 'center', gap: '10px' },
  fecha: { fontSize: '16px', fontWeight: 'bold', color: '#2c3e50' },
  estado: { color: 'white', padding: '4px 12px', borderRadius: '20px', fontSize: '12px' },
  botonEliminarPlan: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  botonReabrirPlan: { backgroundColor: "#f39c12", color: "white", border: "none", padding: "5px 10px", borderRadius: "6px", cursor: "pointer", fontSize: "13px", marginRight: "6px" },
  comentario: { color: '#7f8c8d', marginBottom: '10px' },
  tarjetaFooter: { display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' },
  info: { fontSize: '13px', color: '#95a5a6' },
  alertaBultos: { fontSize: '13px', color: '#e74c3c', fontWeight: 'bold' },
  verDetalle: { fontSize: '13px', color: '#3498db', marginLeft: 'auto' },
  barraContainer: { marginTop: '10px', backgroundColor: '#ecf0f1', borderRadius: '4px', height: '6px', overflow: 'hidden' },
  barraRelleno: { height: '100%', borderRadius: '4px', transition: 'width 0.3s ease' }
};

export default Planes;
